import { AccountManager } from "../../../workers/AccountManager";
import { useEffect } from "react";

/**
 * @author kmy
 * @date 2025-03-28
 * @remark 간편 로그인(네이버)
 * @returns
 */

function NaverLogin() {
    const code = new URL(window.location.href).searchParams.get("code");
    const state = new URL(window.location.href).searchParams.get("state");
    useEffect(() => {
        portalLogin();
    }, []);

    const portalLogin = async () => {
        let param = {
            process: "login",
            platform: "naver",
            code: code,
            state: state,
        };

        const accountManager = AccountManager.getInstance();
        const json = accountManager.portalLoginCallback(param);
    };

    return <div></div>;
}

export default NaverLogin;
